import { authorLinkIcon } from '@/helpers/blog/author';
import arrowRightIcon from '@/assets/img/author/arrow-right.svg';

export default {
  name: 'ContentBlockAuthor',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      arrowRightIcon
    };
  },
  computed: {
    authorRoute() {
      return { name: 'author', params: { slug: this.data.slug } };
    },
    articlesRoute() {
      return { ...this.authorRoute, hash: '#articles' };
    },
    links() {
      return (this.data.links || []).filter(({ url }) => url);
    }
  },
  methods: {
    linkIcon(type) {
      return authorLinkIcon(type);
    }
  }
};
